import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, setDoc, getDoc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { CardContent } from '../components/ui/cardContent';

const generateReferralCode = async (baseName, userId) => {
  const cleanBase = baseName.toLowerCase().replace(/\s+/g, '');
  const suffix = Math.floor(100 + Math.random() * 900);
  const code = `${cleanBase}${suffix}`;
  const refCheck = await getDoc(doc(db, 'referralCodes', code));
  if (refCheck.exists()) {
    return generateReferralCode(baseName, userId); // retry
  } else {
    await setDoc(doc(db, 'referralCodes', code), { uid: userId });
    return code;
  }
};


const Register = () => {
  const [role, setRole] = useState('student');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [referrerId, setReferrerId] = useState('');
  const navigate = useNavigate();

const handleRegister = async (e) => {
  e.preventDefault();
  try {
    const result = await createUserWithEmailAndPassword(auth, email, password);
    if (!result?.user?.uid) throw new Error("User UID not found after registration");

    const today = new Date();
    const demoExpiry = new Date(today);
    demoExpiry.setDate(today.getDate() + 1);

    let referrerName = '';

    if (referrerId) {
      const refDoc = await getDoc(doc(db, 'users', referrerId));
      if (refDoc.exists()) {
        const refData = refDoc.data();
        referrerName = refData.name || '';
        await updateDoc(doc(db, 'users', referrerId), {
          chronos: (refData.chronos || 0) + 10
        });
      }
    }
    const referralCode = await generateReferralCode(name, result.user.uid);


    await setDoc(doc(db, 'users', result.user.uid), {
      role,
      createdAt: new Date().toISOString(),
      name,
      email,
      chronos: 0,
      activeDates: [],
      isActive: true,
      badges: [],
      accessType: 'demo',
      accessExpiry: demoExpiry.toDateString(),
      referrerId,
      referrerName,
      referralCode,
      availablePlans: [
        { label: '7 Days', duration: 7 },
        { label: '30 Days', duration: 30 },
        { label: '6 Months', duration: 180 },
        { label: '1 Year', duration: 365 },
      ]
    });

    navigate('/home');
  } catch (error) {
    alert('Something went wrong. ' + error.message);
    console.error(error);
  }
};


  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-100 via-pink-100 to-yellow-100 px-4">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <Card className="bg-white/80 backdrop-blur-md shadow-xl rounded-3xl border border-purple-200">
          <CardContent className="p-8">
            <h1 className="text-3xl font-bold text-purple-700 mb-1 text-center">👩‍💻 Brainy Buddy</h1>
            <p className="text-center text-sm text-gray-600 mb-6">Join the Brainies Today!</p>
            <form onSubmit={handleRegister} className="space-y-4">
              <select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                required
                className="w-full p-3 border border-purple-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
              >
                <option value="student">Student</option>
                <option value="teacher">Teacher</option>
                <option value="parent">Parent</option>
              </select>
              <input
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="w-full p-3 border border-purple-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
              />
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full p-3 border border-purple-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full p-3 border border-purple-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
              />
               <input
                type="text"
                placeholder="Referrer ID (Free Pro Access)"
                value={referrerId}
                onChange={(e) => setReferrerId(e.target.value)}
                className="w-full p-3 border border-purple-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
              />
              <Button className="w-full bg-purple-600 hover:bg-purple-700 rounded-xl py-3 transition">Free Demo</Button>
           
              </form>
            <p className="text-sm text-center text-gray-600 mt-4">
              Already have an account?{' '}
              <a href="/" className="text-purple-700 underline font-semibold">Login</a>
            </p>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};

export default Register;
